<style lang="stylus">
    .userMenu
        position relative
        z-index 2
        .userMenu-iconbox
            position relative
            display flex
            align-items center
            column-gap 4px
            width 24px
            height 24px
            cursor pointer

            .userMenu-icon
                width 24px
                height 24px
                border-radius 50%
                border 2px solid rgba(0, 0, 0, 0.15)

                &.userMenu-icon-vip
                    border-color #FFD77C

            .userMenu-noicon
                display block
                margin 0 auto
                text-align center
                color #7A5923
                font-size 14px
                div
                    background #FFF8E5
                    border-radius 50%


            .userMenu-vip
                position absolute
                left 16px
                top 12px
                width 12px
                height 12px


        .userMenu-loginbox
            display flex
            align-items center
            justify-content center
            height 24px
            padding 0 12px 0 8px
            color #222222
            background #ffffff
            border-radius 210px
            font-size 12px
            cursor pointer
            user-select none
            &:hover
                background rgba(255,255,255,0.8)

        .userMenu-expandbox
            position absolute
            top 40px
            right 0
            width 260px
            padding 16px
            background #FFFFFF
            box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05), 0px 2px 10px 0px rgba(0, 0, 0, 0.08);
            border-radius 8px

            .userMenu-expandbox-info
                display flex
                align-items center
                margin-bottom 0;
                cursor pointer
                padding: 8px;
                padding-bottom 16px;
                border-bottom 1px solid rgba(0, 0, 0, 0.08)

                .userMenu-expandbox-avatar
                    position relative
                    display flex
                    align-items center
                    column-gap 4px
                    width 44px
                    height 44px
                    cursor pointer
                    margin-right: 12px

                    .userMenu-icon
                        width 44px
                        height 44px
                        border-radius 50%
                        border 2px solid rgba(0, 0, 0, 0.15)

                        &.userMenu-icon-vip
                            border-color #FFD77C

                    .userMenu-noicon
                        display block
                        margin 0 auto
                        line-height 40px
                        text-align center
                        color #7A5923
                        font-size 14px
                        background #FFF8E5
                        border-radius 50%
                    .userMenu-vip
                        position absolute
                        right -3px
                        bottom -5px

                .userMenu-expandbox-textbox
                    width calc(100% - 18px)
                    color #222
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap

                .userMenu-info-nickname
                    font-size 14px
                    line-height 18px
                    font-weight 700
                    margin-bottom 8px

                .userMenu-info-account
                    font-size 12px
                    line-height 16px

                svg
                    width 16px
                    height 16px

            .userMenu-expandbox-divider
                margin 4px 10px
                width calc(100% - 20px)
                height 1px
                background rgba(0, 0, 0, 0.06)

            .userMenu-expandbox-item
                display flex
                align-items center
                width 100%
                padding 6px 8px
                border-radius 4px
                margin-top 4px
                cursor pointer
                >img
                    margin-right: 8px

                .item-icon
                    margin-right: 8px
                    height 20px
                    width 20px;
                    color: var(--svg-color-black)
                    &.language-arrow
                        margin-right 0px
                        height 8px;
                        width 8px;
                        color var(--svg-color-gray-75)

                >p
                    color #222
                    font-size 13px
                    line-height 16px

                &:hover
                    background rgba(242, 244, 249, 0.60)

                .userMenu-expandbox-lang-menu
                    position relative
                    width 100%
                    display flex
                    justify-content:space-between
                    align-items center
                    color #222
                    p
                        textOverflow()
                        font-size 13px

                    >svg
                        margin-right 2px

                    .lang-content
                        right: 241px;
                        top: -4px;
                        position absolute
                        background #fff
                        border-radius: $common-border-radius;
                        box-shadow $box-shadow
                        overflow hidden
                        padding: 6px
                        .lang-item
                            height 30px
                            padding 0 10px
                            white-space nowrap
                            font-size 13px
                            cursor pointer
                            line-height 30px
                            border-radius: 6px;

                        .active-lang
                            color var(--themeColor)

                        .lang-item:hover
                            background $common-hover-color
            .menu-expandbox-item-lang-menu
                position relative
                &:after
                    content: '';
                    position: absolute;
                    width: 38px;
                    z-index: 10000;
                    height: 71px;
                    left: -24px;
                    top: 3px;

            .expand-logout
                margin-top 8px
</style>

<template>
    <div class="userMenu" v-if="isLogin" v-click-outside="closeExpand">
        <div class="userMenu-iconbox" v-if="isLogin" @mouseenter="showExpand" @mouseleave="delayCloseExpand">
            <img v-if="hasIcon" class="userMenu-icon userMenu-icon" :class="{ 'userMenu-icon-vip': vipState }" :src="userInfo.avatar_url" />
            <div v-else class="userMenu-noicon userMenu-icon" :class="{ 'userMenu-icon-vip': vipState }">
                <div>{{ getFirstName() }}</div>
            </div>
            <div class="userMenu-vip" v-if="vipState">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_3706_72878)">
                        <g filter="url(#filter0_i_3706_72878)">
                            <path
                                d="M9.36159 0.75H2.63841C2.24774 0.75 1.89119 0.972561 1.71961 1.32353L0.291819 4.24401C0.114354 4.607 0.16724 5.04046 0.426779 5.35013L5.21616 11.0647C5.62492 11.5525 6.37508 11.5525 6.78384 11.0647L11.5732 5.35013C11.8328 5.04046 11.8856 4.607 11.7082 4.24401L10.2804 1.32354C10.1088 0.972561 9.75226 0.75 9.36159 0.75Z"
                                fill="url(#paint0_linear_3706_72878)"
                            />
                        </g>
                        <path
                            d="M3.375 5.25H4.125L6 7.875L7.875 5.25H8.625"
                            stroke="white"
                            stroke-opacity="0.8"
                            stroke-width="1.125"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </g>
                    <defs>
                        <filter
                            id="filter0_i_3706_72878"
                            x="0.1875"
                            y="0.75"
                            width="11.625"
                            height="11.8055"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                        >
                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                            <feOffset dy="1.125" />
                            <feGaussianBlur stdDeviation="0.75" />
                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.898667 0 0 0 0 0.366667 0 0 0 0.3 0" />
                            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3706_72878" />
                        </filter>
                        <linearGradient
                            id="paint0_linear_3706_72878"
                            x1="1.875"
                            y1="0.750001"
                            x2="10.3447"
                            y2="10.6878"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#FFDE54" />
                            <stop offset="1" stop-color="#FF9300" />
                        </linearGradient>
                        <clipPath id="clip0_3706_72878">
                            <rect width="12" height="12" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
        </div>

        <div class="userMenu-loginbox" v-else>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <circle cx="12.5" cy="8.5" r="3" stroke="#222222" />
                <path
                    d="M6.08644 18.1013C6.5843 15.5422 9.21763 13.5 12.5 13.5C15.7824 13.5 18.4157 15.5422 18.9136 18.1013C18.933 18.2011 18.9043 18.2896 18.8348 18.3634C18.7609 18.442 18.641 18.5 18.5 18.5H6.5C6.35904 18.5 6.23913 18.442 6.16517 18.3634C6.09566 18.2896 6.06703 18.2011 6.08644 18.1013Z"
                    stroke="#222222"
                />
            </svg>
            <p>{{ $t("logIn") }}</p>
        </div>

        <div class="userMenu-expandbox" v-if="showExpandBox" @mouseenter="cleanDelayClose" @mouseleave="closeExpand">
            <div v-if="showInfo" class="userMenu-expandbox-info" @click="openAccountCenter">
                <div class="userMenu-expandbox-avatar">
                    <img v-if="hasIcon" class="userMenu-icon userMenu-icon" :class="{ 'userMenu-icon-vip': vipState }" :src="userInfo.avatar_url" />
                    <div v-else class="userMenu-noicon userMenu-icon" :class="{ 'userMenu-icon-vip': vipState }">
                        {{ getFirstName() }}
                    </div>
                    <div class="userMenu-vip" v-if="vipState">
                        <img :src="require('@/home/assets/img/user/topbar/expand/vip.svg')" alt="" />
                    </div>
                </div>
                <div class="userMenu-expandbox-textbox">
                    <p v-tippy="{ content: userInfo.nick_name, placement: 'left' }" class="userMenu-info-nickname">{{ userInfo.nick_name }}</p>
                    <p v-tippy="{ content: infoAccount, placement: 'left' }" class="userMenu-info-account" v-if="infoAccount">{{ infoAccount }}</p>
                </div>
            </div>
            <CloudSpace v-if="showCloud" />
            <a v-if="showAccountCenter" class="userMenu-expandbox-item" target="_blank" :href="accountCenterLink" style="margin-top: 8px">
                <iconSymbol class="item-icon" name="usermenu-center" />
                <p>{{ $t("userCenter") }}</p>
            </a>
            <div v-if="showUserPage" class="userMenu-expandbox-item" @click="openUserPage()">
                <iconSymbol class="item-icon" name="usermenu-page" />
                <p>{{ $t("userInfo") }}</p>
            </div>
            <a v-if="showHomeLink" class="userMenu-expandbox-item" :href="homeUrl" target="blank">
                <iconSymbol class="item-icon" name="usermenu-home" />
                <p>{{ $t("home") }}</p>
            </a>
            <div
                v-if="showMiniProgramEntry"
                class="userMenu-expandbox-item"
                @mouseenter="showMiniprogram($event, 'account')"
                @mouseleave="hiddenMiniprogram"
            >
                <iconSymbol class="item-icon" name="usermenu-miniprogram" />
                <p>{{ $t("miniprogram_wx") }}</p>
            </div>
            <div
                class="userMenu-expandbox-item menu-expandbox-item-lang-menu"
                @click.stop
                @mouseenter="handleLangMouseEnter"
                @mouseleave="handleLangMouseLeave"
            >
                <div class="userMenu-expandbox-lang-menu">
                    <div style="display: flex; align-items: center; justify-content: space-between; width: 100%">
                        <div style="display: flex; align-items: center">
                            <!-- <img :src="require('@/home/assets/img/user/topbar/expand/language.svg')" alt="" style="margin-right: 8px" /> -->
                            <iconSymbol class="item-icon language-icon" name="usermenu-language" />
                            <p>{{ $t("language") }}</p>
                        </div>
                        <iconSymbol class="item-icon language-arrow" name="usermenu-arrow" />
                    </div>
                    <div class="lang-content" v-show="showLangSlider">
                        <div
                            class="lang-item"
                            :class="{ 'active-lang': item.value == lang }"
                            v-for="(item, index) in langList"
                            v-tippy="{ content: item.lang, placement: 'left' }"
                            :key="index"
                            @click="setLang(item, $event)"
                        >
                            {{ item.lang }}
                        </div>
                    </div>
                </div>
            </div>
            <a v-if="showGroupBtn" class="userMenu-expandbox-item" :href="teamLink" target="blank">
                <img :src="require('@/home/assets/img/user/topbar/expand/team.svg')" alt="" />
                <p>{{ $t("team") }}</p>
            </a>
            <div v-if="showLogout" class="userMenu-expandbox-divider" style="margin: 8px 0; width: 100%"></div>
            <div v-if="showLogout" class="userMenu-expandbox-item expand-logout" @click.stop="logout()">
                <iconSymbol class="item-icon" name="usermenu-logout" />
                <p>{{ $t("logout") }}</p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import CloudSpace from "@/home/parts/CloudSpace.vue";
    declare var AutoSaveTimer;
    declare var EDDocument;

    @Component({
        components: {
            CloudSpace,
        },
    })
    export default class UserMenu extends Vue {
        @Prop()
        from;
        @Prop()
        userInfo;
        @Prop()
        vipState;
        @Prop({ default: true })
        showCloud;

        get isLogin() {
            return this.userInfo;
        }
        get hasIcon() {
            return this.userInfo && this.userInfo.avatar_url;
        }

        getFirstName() {
            return (this.userInfo?.nick_name || "").trim().split("")[0];
        }

        // expand box
        showExpandBox = false;
        showExpand() {
            this.showExpandBox = !this.showExpandBox;
        }
        closeExpand() {
            this.showExpandBox = false;
        }
        delayTimer = 0;
        delayCloseExpand() {
            this.delayTimer = setTimeout(() => {
                this.showExpandBox = false;
            }, 200);
        }
        cleanDelayClose() {
            clearTimeout(this.delayTimer);
        }
        get showInfo() {
            return !this.isPrivate;
        }
        get infoAccount() {
            if (this.userInfo.mobile) {
                return this.userInfo.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
            }
            return this.userInfo.email;
        }
        get showAccountCenter() {
            return !this.isPrivate && !this.isTeamsApp;
        }
        get accountCenterLink() {
            return this.urls.accountUrl + `?lang=${this.lang}&tend=max`;
        }
        get showUserPage() {
            return !this.isPrivate && !this.isTeamsApp && this.from != "app";
        }
        get showMiniProgramEntry() {
            return this.internal && !this.isPrivate;
        }
        get showHomeLink() {
            return !this.isPrivate && !this.isTeamsApp;
        }
        get teamLink() {
            return this.internal ? "https://account.edrawsoft.cn/team?tend=max" : "https://account.edrawsoft.com/team?tend=max";
        }
        get homeUrl() {
            if (this.internal) {
                return "https://www.edrawmax.cn/?stay=1";
            } else {
                if (["en", "kr", "tw", "zh"].includes(this.lang)) {
                    return "https://www.edrawsoft.com/";
                } else {
                    return `https://www.edrawsoft.com/${this.lang}`;
                }
            }
        }
        openAccountCenter() {
            window.open(this.urls.accountUrl + `?lang=${this.lang}&tend=max`);
        }
        openUserPage() {
            let id = this.userInfo.user_id;
            if (this.isPC && this.internal) {
                this.$store.commit("toVisitUser", {
                    id,
                });
                this.$store.commit("toTplCenter", {
                    name: "showUserWorks",
                    data: true,
                });
            } else {
                let path = this.internal ? "templates/user" : "templates/users";
                let href = `${window.location.origin}/${path}/${id}`;
                if (this.isPC) {
                    (<any>window).$qt.jsCallOpenUrl(href);
                } else {
                    window.open(href);
                }
            }
        }
        hiddenMiniprogram() {
            this.$store.commit("setMiniProgram", {
                show: false,
            });
        }
        showMiniprogram(e, type) {
            let rect = e.target.getBoundingClientRect();
            let direction = 2;
            this.$store.commit("setMiniProgram", {
                show: true,
                left: rect.x - 10,
                top: rect.y,
                direction: direction,
            });
        }
        langList = [];
        showLangSlider: boolean = false;
        langTimer: number | null = null;
        handleLangMouseEnter() {
            clearTimeout(this.langTimer);
            this.showLangSlider = true;
        }

        handleLangMouseLeave() {
            this.langTimer = setTimeout(() => {
                this.showLangSlider = false;
            }, 150);
        }
        setLang(item) {
            if (this.from == "home") {
                let replaceUrl = () => {
                    this.$store.commit("changeUILang", item.value);
                    this.$router
                        .replace({
                            params: { lang: item.value },
                            query: this.$route.query,
                        })
                        .catch((err) => {});
                };
                if (!this.userInfo) {
                    // 未登录状态设置语言
                    replaceUrl();
                } else {
                    this.$track("Newpage", "setlang", item.value);
                    this.$store.dispatch("setLang", { lang: item.value }).then((res) => {
                        this.$bus.$emit("changeLang", { lang: item.value });
                        replaceUrl();
                    });
                }
                this.changeLoginLang(item.value);
            } else {
                const v = item.value;
                this.$track("modal", "options", "set language");
                this.$store.commit("changeUILang", v);
                this.$store.dispatch("setUserPrefer", { language: v });
                EDDocument.s_themeManager.langThemeText(v);
                window["_view"].updateOrgLanguage();
                window["_view"].updateGanttLanguage();
                window["_view"].updateActionLanguage();
                this.$store.commit("cleanNewLibraryDisplayList"); // 清除符号库预览缓存
            }
            // 关闭lang侧拉窗
            this.showLangSlider = false;
            this.sensors.registerPage({
                plang: item.value === "zh" ? "cn" : item.value,
            });
            // 关闭下拉窗
            this.closeExpand();
        }
        changeLoginLang(lang) {
            // 更改登录窗口语言
            let iframe = document.getElementById("edraw-authorization--wrapper");
            if (iframe) {
                let baseURL = iframe.children[1].getAttribute("src");
                let tempURL = new URL(baseURL);
                let urlS = new URLSearchParams(baseURL);
                if (!this.internal) {
                    // 兼容wsid语言
                    switch (lang) {
                        case "zh": {
                            lang = "zh-cn";
                            break;
                        }
                        case "tw": {
                            lang = "zh-tw";
                            break;
                        }
                        case "jp": {
                            lang = "ja-jp";
                            break;
                        }
                        case "de": {
                            lang = "de-de";
                            break;
                        }
                        case "fr": {
                            lang = "fr-fr";
                            break;
                        }
                        case "es": {
                            lang = "es-es";
                            break;
                        }
                        case "it": {
                            lang = "it-it";
                            break;
                        }
                        case "pt": {
                            lang = "pt-br";
                            break;
                        }
                        case "kr":
                        case "ko": {
                            lang = "ko-kr";
                            break;
                        }
                        default: {
                            lang = "en-us";
                        }
                    }
                }
                if (urlS.get("lang")) {
                    baseURL = baseURL.replace(/lang=.[^\&]*/, `lang=${lang}`);
                } else {
                    if (tempURL.search) {
                        baseURL = baseURL += `&lang=${lang}`;
                    } else {
                        baseURL = baseURL += `?lang=${lang}`;
                    }
                }
                iframe.children[1].setAttribute("src", baseURL);
            }
        }

        get showLogout() {
            return !this.isWorkwx;
        }
        logout() {
            if (this.from == "home") {
                this.$track("Newpage", "logout");
                let ts: any = this;
                ts.$bus.$emit("logout");
            } else {
                window["_view"]._tool.endEdit();
                this.$track("fastTool", "logout");
                let ts: any = this;
                if (this.$store.state.user.userInfo) {
                    if (AutoSaveTimer) {
                        (<any>this).$Modal.confirm({
                            title: this.$t("tip"),
                            content: this.$t("saveTip"),
                            okText: this.$t("confirm"),
                            cancelText: this.$t("cancel"),
                            onOk: () => {
                                this.$root["ui"]
                                    .toSaving(true, false, true, "logout")
                                    .then((res) => {
                                        ts.$bus.$emit("logout");
                                    })
                                    .catch((err) => {});
                            },
                            onCancel: () => {
                                if (ts.$store.state.user.notCloudFile) {
                                    // 非本人文件时弹出登录窗口
                                    ts.$bus.$emit("notCloudFileLogout");
                                }
                            },
                        });
                    } else {
                        ts.$bus.$emit("logout");
                    }
                } else {
                    ts.$bus.$emit("login");
                }
            }
        }
        login() {
            if (this.from == "app") {
                window["_view"]._tool.endEdit();
                let ts: any = this;
                ts.$bus.$emit("login");
            } else {
                // home页面暂无登录
            }
        }
        showGroupBtn = false;
        checkGroupRole() {
            if (this.userInfo?.user_id) {
                this.$edApi
                    .getGroupRole({
                        id: this.userInfo.user_id,
                        token: this.userInfo.token,
                    })
                    .then((res) => {
                        let data = res.data.data;
                        if (data) {
                            this.showGroupBtn = [1, 2].includes(data.role);
                        }
                    });
            }
        }
        @Watch("userInfo", { immediate: true })
        watchUserInfo(nv, ov) {
            if (nv?.user_id) {
                this.checkGroupRole();
            }
        }
        created() {}
        mounted() {
            this.langList = [
                {
                    lang: "简体中文",
                    value: "zh",
                },
                {
                    lang: "English",
                    value: "en",
                },
                // {
                //     lang: '繁体中文',
                //     value: 'tw',
                // }
            ];
            if (!this.internal) {
                let arr = [
                    {
                        lang: "Francais",
                        value: "fr",
                    },
                    {
                        lang: "Deutsch",
                        value: "de",
                    },
                    {
                        lang: "日本语",
                        value: "jp",
                    },
                    {
                        lang: "Español",
                        value: "es",
                    },
                    {
                        lang: "Italiano",
                        value: "it",
                    },
                    {
                        lang: "Português",
                        value: "pt",
                    },
                    // {
                    //     lang: '韩语',
                    //     value: 'kr',
                    // }
                ];
                this.langList = this.langList.concat(arr);
            }
        }
    }
</script>
<i18n>
{
    "zh": {
        "logout": "退出",
        "login": "登录",
        "userCenter": "用户中心",
        "language": "语言设置",
        "userInfo": "作品主页",
        "home": "亿图官网",
        "miniprogram_wx": "小程序",
        "tip": "Edraw 提醒",
        "saveTip": "文档有改动尚未保存，是否现在保存？",
        "confirm": "确认",
        "cancel": "取消",
        "dilatancy": "扩容",
        "team": "企业管理"
    },
    "en": {
        "logout": "Logout",
        "login": "Login",
        "userCenter": "My Account",
        "language": "Language Setting",
        "userInfo": "My home page",
        "home": "Edrawsoft",
        "miniprogram_wx": "Miniprogram",
        "tip": "Edraw tips",
        "saveTip": "The document has been changed. Do you want to save now?",
        "confirm": "OK",
        "cancel": "Cancel",
        "dilatancy": "Expand Cloud Storage",
        "team": "Enterprise Management"
    },
    "fr": {
        "logout": "Se déconnecter",
        "login": "s'identifier",
        "userCenter": "Mon Compte",
        "language": "Paramètres de langue",
        "feedBack": "Centre de rétroaction",
        "userInfo": "Ma page d'accueil",
        "tip": "Rappel Edraw",
        "saveTip": "Le document n'a pas été enregistré. Voulez-vous l'enregistrer maintenant?",
        "confirm": "Confirmer",
        "cancel": "Annuler",
        "dilatancy": "Etendre l'espace de stockage du Cloud",
        "team": "Gestion d'entreprise"
    },
    "de": {
        "logout": "Abmelden",
        "login": "Anmelden",
        "userCenter": "Mein Konto",
        "language": "Sprache",
        "feedBack": "Feedback",
        "userInfo": "Meine Homepage",
        "tip": "Edraw Tipps",
        "saveTip": "Das Dokument wurde geändert. Möchten Sie jetzt speichern?",
        "confirm": "Sichern",
        "cancel": "Abbrechen",
        "dilatancy": "Cloud-Speicher erweitern",
        "team": "Geschäftsmanagement"
    },
    "jp": {
        "logout": "ログアウト",
        "login": "ログイン",
        "userCenter": "私のアカウント",
        "language": "言語",
        "feedBack": "フィードバック",
        "userInfo": "マイページ",
        "tip": "Edrawからのご注意",
        "saveTip": "ドキュメントは保存されていません。今すぐ保存しますか？",
        "confirm": "確認",
        "cancel": "キャンセル",
        "dilatancy": "容量の追加",
        "team": "ビジネス管理"
    },
    "es": {
        "logout": "Cerrar sesión",
        "login": "Iniciar sesión",
        "userCenter": "Mi Cuenta",
        "language": "Configuración de idioma",
        "feedBack": "Feedback",
        "userInfo": "Mi página de inicio",
        "tip": "Consejos de Edraw",
        "saveTip": "El documento ha sido modificado. ¿Quieres guardar ahora?",
        "confirm": "Aceptar",
        "cancel": "Cancelar",
        "dilatancy": "Ampliar espacio en la nube",
        "team": "Dirección comercial"
    },
    "pt": {
        "logout": "Desconectar",
        "login": "Conectar",
        "userCenter": "Minha Conta",
        "language": "Configuração de Língua",
        "feedBack": "Feedback",
        "userInfo": "Minha página inicial",
        "tip": "Dicas Edraw",
        "saveTip": "O documento foi alterado. Deseja gravar agora?",
        "confirm": "OK",
        "cancel": "Cancelar",
        "dilatancy": "Expandir Armazenamento na Núvem",
        "team": "Gestão Empresarial"
    },
    "it": {
        "logout": "Esci",
        "login": "Accedi",
        "userCenter": "Il Mio Account",
        "language": "Impostazioni Lingua",
        "feedBack": "Feedback",
        "userInfo": "La mia Homepage",
        "tip": "Suggerimenti di Edraw",
        "saveTip": "Il documento è stato modificato. Desideri salvarlo?",
        "confirm": "OK",
        "cancel": "Annulla",
        "dilatancy": "Espandi l'Archiviazione di Cloud",
        "team": "Gestione aziendale"
    },
    "tw": {
        "logout": "登出",
        "login": "登入",
        "userCenter": "我的帳戶",
        "language": "語言設置",
        "feedBack": "反饋中心",
        "userInfo": "我的主頁",
        "tip": "Edraw 提醒",
        "saveTip": "檔案有改動尚未儲存，是否現在儲存？",
        "confirm": "確認",
        "cancel": "取消",
        "dilatancy": "擴充雲端硬碟儲存空間"
    },
    "kr": {
        "logout": "로그아웃",
        "login": "로그인",
        "userCenter": "나의 계정",
        "language": "언어 설정",
        "feedBack": "피드백",
        "userInfo": "사용자 정보",
        "tip": "Edraw 팁",
        "saveTip": "문서가 변경되었습니다. 지금 저장하시겠습니까?",
        "confirm": "확인 ",
        "cancel": "취소",
        "dilatancy": "클라우드 스토리지 확장"
    },
    "id": {
        "logout": "Keluar",
        "login": "Masuk",
        "userCenter": "Pusat Pengguna",
        "language": "Pengaturan Bahasa",
        "feedBack": "Umpan Balik",
        "userInfo": "Halaman beranda saya",
        "dilatancy": "Tingkatkan Penyimpanan Cloud"
    }
}
</i18n>
